import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, FormattedMessage, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';

import types from '../../common/model-api/types';
import {getLastOrganisationId} from '../app/LastOrganisationId';
//import xmlFormatter from 'xml-formatter';
import {FetchRenderer} from './FetchView.react';
import { User } from '../../common/types/types';


const messages = defineMessages({
    title: { id: 'fetchView.title', 'defaultMessage': 'API Requests' },
    hidden: { id: 'fetchView.hidden.title', defaultMessage: 'All authentication information are not stored in logs for security reasons.'},
	serverTimestamp: { id: 'fetchView.timestamp', 'defaultMessage': 'Server time: {time}' },
});

interface FetchViewProps {
    intl: IntlShape;
    relay: object;
    user: User;
}

class FetchView extends React.Component<FetchViewProps> {

    typeName = 'fetches';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    render() {
        const data = this.props.user.organisation.fetch;
        let type = types[this.typeName];


        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>

				<h3><FormattedMessage defaultMessage="API Request detail:" id="fetches.listDetail" /> {data.sourceDef ? data.sourceDef.name : null}</h3>

                <FetchRenderer fetch={data} intl={this.props.intl} relay={this.props.relay} />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(FetchView), (props) => {
    return props.user.organisation && props.user.organisation.fetch;
}), {
    initialVariables: {
        organisationId: '',
        fetchId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    fetch(id: $fetchId) {
                        createdAt,
                        success,
                        id,
                        realId,
                        duration,
                        delay,
                        error,
                        errorType,
                        request,
                        ignoredError,
                        dataPreview,
                        dataLength,
                        channel_id,
                        server,
                        channel {
                            id,
                            name,
                        },
                        channelDef {
                            id,
                            name,
                            icon
                        },
                        organisation_id,
                        organisation {
                            id,
                            name,
                        },
                        actionDef {
                            name,
                            id
                        },
                        sourceDef {
                            name,
                            id
                        },
						user {
							id,
							firstname,
							surname,
							email,
							picture
						},
                        flow {
                            name,
                            id,
                            organisation_id,
                            realId,
                            flowDef {
    							id,
    							name,
    						},
                        },
						flowDef {
                            name,
                            id
                        },
						flowStepDef {
                            name,
                            id
                        },
						name
                    }
                }
            }
        `,
    },
});
